import axios from 'axios';
import qs from 'qs';
import networkConf from './Config/network';
import { getLocationLanguageParam } from '../Utils/getLocationLanguageParam';

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

/**
 * axios instance to handle API requests
 */
const ax = axios.create({
  baseURL: networkConf.baseURL,
  timeout: networkConf.timeout,
  cancelToken: source.token,

  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

const setLanguageParam = (config) => {
  config.params._language = getLocationLanguageParam();
};

export function createRequest() {
  let cancelSource = CancelToken.source();
  return {
    request: (config, params) => {
      config = typeof config === 'string' ? { url: config } : config;
      const mixedConfig = {
        ...ax.defaults,
        ...config,
        cancelToken: cancelSource.token,
        params: params || {},
      };
      setLanguageParam(mixedConfig);
      return axios.request(mixedConfig);
    },
    cancel: () => {
      cancelSource.cancel();
      cancelSource = CancelToken.source();
    },
  };
}
